import { DataSource } from "@angular/cdk/collections";
import { User } from "common/class/user";
import { Logger } from "common/utility/logger/logger";
import { BehaviorSubject, catchError, finalize, Observable, of, Subject, takeUntil } from "rxjs";
import { UserService } from "services/user/user.service";


export class UsersDataSource implements DataSource<User> {

    private users = new BehaviorSubject<Array<User>>([]);
    private loading = new BehaviorSubject<boolean>(false);
    private unsubscribe: Subject<void> = new Subject()


    public get Users(): Observable<Array<User>> {
        return this.users.asObservable()
    }

    public get Loading(): Observable<boolean> {
        return this.loading.asObservable()
    }

    public connect(): Observable<User[]> {
        // this.watchDataChanges()
        this.userService.UsersRefreshed
            .pipe(takeUntil(this.unsubscribe))
            .subscribe((users) => {
                this.users.next(users)
            })
        return this.users.asObservable();
    }

    public disconnect(): void {
        this.loading.complete();
    }

    public loadUsers(): void {
        this.loading.next(true);

        this.userService.refreshUsers().pipe(
            catchError(() => of([])),
            finalize(() => this.loading.next(false))
        ).subscribe(users => {
            Logger.debug(`Received new User Data`, users)
        });
    }


    public sorted(users: Array<User>): void {
        this.users.next(users)
    }

    public destroy(): void {
        this.unsubscribe.next()
        this.unsubscribe.complete()
    }

    constructor(
        private userService: UserService
    ) { }
}